export default function SwiggyDashboard(){
    return <div>Swiggy Dashboard</div>
}